/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Overage_On_DescInputs */



/**
* | output |
* | --- |
* | "When pool is empty, continue using paid models with pay-per-use" |
*
* @param {Usage_Tab_Overage_On_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_overage_on_desc = /** @type {((inputs?: Usage_Tab_Overage_On_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Overage_On_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn der Pool leer ist, weiterhin kostenpflichtige Modelle mit Pay-per-Use nutzen")
	return /** @type {LocalizedString} */ ("When pool is empty, continue using paid models with pay-per-use")
});